const DEBUG_ENTRY_DEPLOY_ENVS = new Set(['qa', 'stage']);

/**
 * 判断当前构建是否允许展示全局 Debug 入口。
 */
export function isDebugEntryEnvironment(isDev: boolean, deployEnv?: string): boolean {
    return isDev || DEBUG_ENTRY_DEPLOY_ENVS.has((deployEnv || '').toLowerCase());
}
